/**
 * Automatically resizes iframes based on the amount of content
 */
 
import $ from 'jquery';
require('../plugins/iframeResizer.min.js');

// Cached elements
const $el = {
	iframe: $('.js-iframe')
};

// Module events
export default function init() {
	if (!$el.iframe.length) return;

	$el.iframe.iFrameResize();
}
